// extracted by mini-css-extract-plugin
export default {"wrapper":"message-box_wrapper__8YYrG"};